import React from 'react'

import Wrapper from '../Wrapper'
import MessageUs from 'screens/Metabar/Support/MessageUs'

const NoteNotFound = () => (
  <Wrapper
    title={"We couldn't find the doc you're looking for"}
    subtitle={"The doc you're asking for doesn't seem to exists"}
  >
    <div>
      Please verify you have the right link.
      <br />
      <MessageUs /> if this error persists
    </div>
  </Wrapper>
)

export default NoteNotFound
